const C = require("../constants");
const initial_data = {id:null, name:' ', price:0, has_expiration:false, expiration_days:0, products:[]};

function TicketSelectReducer(state = initial_data, action) {
    switch (action.type) {
        case C.TICKET_SELECT:
            return action.data;
        default:
            return state;
    }
}

export default TicketSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/TicketSelectReducer.js